(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-pure"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('product-reviews');
  var grid = document.getElementById('reviews-grid');
  if(!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-review-card]'));
  var btn   = document.querySelector('[data-reviews-toggle]');
  if(cards.length === 0 || !btn) return;

  function isMobile(){
    return window.matchMedia('(max-width: 820px)').matches;
  }

  function baseLimit(){
    return isMobile()
      ? parseInt(grid.dataset.initialMobile || '2', 10)
      : parseInt(grid.dataset.initialDesktop || '10', 10);
  }

  // Mobiel: 'collapsed' -> 'partial' (+5) -> 'expanded' (alles)
  // Desktop: expanded true/false
  var mode = 'collapsed';     // alleen gebruikt op mobiel
  var expanded = false;       // gebruikt op desktop

  function partialLimit(){
    // op mobiel: max 5 extra boven de basis
    var bl = baseLimit();
    var pl = bl + 5;
    return Math.min(pl, cards.length);
  }

  function applyLimit(){
    var bl = baseLimit();
    var limit;

    if(isMobile()){
      if(mode === 'collapsed'){
        limit = bl;
        btn.textContent = (cards.length > bl) ? 'Meer weergeven' : 'Alles weergeven';
        btn.setAttribute('aria-expanded', 'false');
      }else if(mode === 'partial'){
        limit = partialLimit();
        // Als er na partial nog méér is, toon "Alles weergeven", anders meteen "Minder weergeven"
        if(cards.length > limit){
          btn.textContent = 'Alles weergeven';
          btn.setAttribute('aria-expanded', 'false');
        }else{
          btn.textContent = 'Minder weergeven';
          btn.setAttribute('aria-expanded', 'true');
        }
      }else{ // expanded
        limit = cards.length;
        btn.textContent = 'Minder weergeven';
        btn.setAttribute('aria-expanded', 'true');
      }
    }else{
      // Desktop: standaard 2-staps
      limit = expanded ? cards.length : bl;
      btn.textContent = expanded ? 'Minder weergeven' : 'Meer weergeven';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    cards.forEach(function(el, idx){
      el.style.display = (idx < limit) ? '' : 'none';
    });

    // Knop tonen alleen als er meer zijn dan de basislimiet
    if(cards.length > bl){
      btn.hidden = false;
    }else{
      btn.hidden = true;
    }
  }

  btn.addEventListener('click', function(){
    if(isMobile()){
      if(mode === 'collapsed'){
        mode = 'partial';
      }else if(mode === 'partial'){
        // Als partial al alles toont, ga direct naar collapsed bij volgende klik
        if(partialLimit() >= cards.length){
          mode = 'collapsed';
          applyLimit();
          // Scroll terug naar de knop/sectie zodat je niet "onderaan" belandt
          setTimeout(function(){
            (btn.closest('.prv__morewrap') || btn).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 0);
          return;
        }else{
          mode = 'expanded';
        }
      }else{ // expanded -> collapsed + vriendelijke scroll
        mode = 'collapsed';
        applyLimit();
        setTimeout(function(){
          (btn.closest('.prv__morewrap') || btn).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 0);
        return;
      }
    }else{
      expanded = !expanded;
      if(!expanded){
        // Na inklappen op desktop ook terug naar de knop zodat je niet onderaan hangt
        applyLimit();
        setTimeout(function(){
          (btn.closest('.prv__morewrap') || btn).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 0);
        return;
      }
    }
    applyLimit();
  });

  // Bij resize: reset logica naar de juiste modus
  var lastIsMobile = isMobile();
  window.addEventListener('resize', function(){
    var nowIsMobile = isMobile();
    if(nowIsMobile !== lastIsMobile){
      // wissel tussen modi
      mode = 'collapsed';
      expanded = false;
      lastIsMobile = nowIsMobile;
    }
    // Alleen opnieuw toepassen als niet expanded (desktop) of we zetten gewoon veilig opnieuw
    applyLimit();
  });

  // Init
  applyLimit();

  /* ===== Lightbox ===== */
  var lightbox = document.querySelector('[data-lightbox]');
  var lightImg = lightbox ? lightbox.querySelector('.prv__lightbox-img') : null;
  var closeBtn = lightbox ? lightbox.querySelector('.prv__lightbox-close') : null;

  grid.addEventListener('click', function(e){
    var btnMedia = e.target.closest('[data-review-zoom]');
    if(!btnMedia || !lightbox || !lightImg) return;
    var img = btnMedia.querySelector('img');
    if(!img) return;
    var src = img.currentSrc || img.src;
    try{
      var url = new URL(src, window.location.origin);
      if(url.searchParams.has('height')) url.searchParams.delete('height');
      if(url.searchParams.has('crop')) url.searchParams.delete('crop');
      src = url.toString();
    }catch(err){}
    lightImg.src = src;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  });

  function closeLightbox(){
    if(!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if(lightImg) lightImg.src = '';
  }

  if(closeBtn) closeBtn.addEventListener('click', closeLightbox);
  if(lightbox){
    lightbox.addEventListener('click', function(e){
      if(e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
